import { render, staticRenderFns } from "./ViewCandle.vue?vue&type=template&id=45d8e2dc&scoped=true&"
import script from "./ViewCandle.vue?vue&type=script&lang=js&"
export * from "./ViewCandle.vue?vue&type=script&lang=js&"
import style0 from "./ViewCandle.vue?vue&type=style&index=0&id=45d8e2dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d8e2dc",
  null
  
)

export default component.exports